import type { GroupResult } from '../types'

/**
 * The headline result is the number of points earned, not a percentage
 * (Jerome's request 1: "4150" rather than "41%"). Percentages still drive the
 * per-group bars and the qualitative label, they just aren't the headline.
 */
export function totalPoints(groups: GroupResult[] | undefined): number {
  if (!groups || groups.length === 0) return 0
  return groups.reduce((sum, g) => sum + (g.total_score || 0), 0)
}

export function maxPoints(groups: GroupResult[] | undefined): number {
  if (!groups || groups.length === 0) return 0
  return groups.reduce((sum, g) => sum + (g.max_possible_score || 0), 0)
}

/** Grouped thousands, matching the legacy HIT display ("4,150"). */
export function formatPoints(points: number): string {
  return Math.round(points).toLocaleString('en-US')
}
